function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.2984763 0h23.1904421c7.1321499 0 9.7184398.74260489 12.3258472 2.13706163 2.6074074 1.39445674 4.653716 3.44076533 6.0481728 6.04817274l.0828844.15645564C63.2868023 10.8979117 64 13.5215747 64 20.5110816v22.9778368c0 7.1321499-.7426049 9.7184398-2.1370616 12.3258472-1.3944568 2.6074074-3.4407654 4.653716-6.0481728 6.0481728l-.1564556.0828844C53.1020883 63.2868023 50.4784253 64 43.4889184 64H20.5110816c-7.1321499 0-9.7184398-.7426049-12.32584723-2.1370616-2.60740741-1.3944568-4.653716-3.4407654-6.04817274-6.0481728l-.08288446-.1564556C.7268812 53.1281722.01462042 50.5319624 0 43.7015237V20.5110816c0-7.1321499.74260489-9.7184398 2.13706163-12.32584723 1.39445674-2.60740741 3.44076533-4.653716 6.04817274-6.04817274l.15645564-.08288446C10.8718278.7268812 13.4680376.01462042 20.2984763 0z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#B933FF"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M8 32.0545751l9.02765796 10.7645873L42.964467 21.04626524 32.0394126 11.875z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M56 32.0545751L31.9605874 11.875 21.035533 21.04626524 46.972342 42.8191624z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M39.0659898 52.1998731V17.81269394L32 11.875l-7.0659898 5.93769394V52.1998731z"
})));

var Svg3ChartsWhiteBordered = function Svg3ChartsWhiteBordered(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg3ChartsWhiteBordered, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/3charts-white-bordered.30f344d7.svg";
export { ForwardRef as ReactComponent };